import React from 'react';

export default function DeleteData({ onBack }) {
  return (
    <div className="main-page" style={{ paddingTop: 'env(safe-area-inset-top, 16px)' }}>
      <div className="page-container" style={{ maxWidth: 700, padding: '32px 16px 48px' }}>

        {onBack && (
          <button onClick={onBack} style={{ background: 'none', border: 'none', color: 'var(--gold)', fontSize: 15, cursor: 'pointer', marginBottom: 24, display: 'flex', alignItems: 'center', gap: 8 }}>
            ← Back
          </button>
        )}

        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(28px, 4vw, 40px)', marginBottom: 8, lineHeight: 1.2 }}>
          Data Deletion Request
        </h1>
        <p style={{ color: 'var(--white-40)', fontSize: 13, marginBottom: 32 }}>My Tapping Script</p>

        <p style={{ color: 'var(--white-80)', fontSize: 15, lineHeight: 1.8, marginBottom: 36 }}>
          If you would like to request deletion of your account and all associated personal data, please follow the steps below.
        </p>

        {/* Option 1 */}
        <div className="card" style={{ marginBottom: 20, borderColor: 'var(--gold-20)' }}>
          <p style={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.1em', color: 'var(--gold)', marginBottom: 16 }}>
            OPTION 1 — DELETE IN APP
          </p>
          <ol style={{ paddingLeft: 20, margin: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>
            {[
              'Open My Tapping Script',
              'Go to Profile',
              'Scroll to the bottom',
              'Tap "Delete Account"',
            ].map((step, i) => (
              <li key={i} style={{ color: 'var(--white-80)', fontSize: 15, lineHeight: 1.6 }}>{step}</li>
            ))}
          </ol>
          <div style={{ marginTop: 16, background: 'var(--white-10)', borderRadius: 8, padding: '12px 16px' }}>
            <p style={{ fontSize: 14, color: 'var(--white-60)', lineHeight: 1.6 }}>
              Your account and all associated data will be permanently deleted within <strong style={{ color: 'var(--white-80)' }}>7 days</strong>.
            </p>
          </div>
        </div>

        {/* Option 2 */}
        <div className="card" style={{ marginBottom: 20, borderColor: 'var(--gold-20)' }}>
          <p style={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.1em', color: 'var(--gold)', marginBottom: 16 }}>
            OPTION 2 — EMAIL REQUEST
          </p>
          <p style={{ color: 'var(--white-80)', fontSize: 15, lineHeight: 1.8, marginBottom: 16 }}>
            If you are unable to access your account, send an email to:
          </p>
          <a href="mailto:info@michaelhetherington.com" style={{ display: 'block', color: 'var(--gold)', fontSize: 16, fontWeight: 600, marginBottom: 20, textDecoration: 'none' }}>
            info@michaelhetherington.com
          </a>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {[
              { label: 'Subject line', value: 'Data Deletion Request' },
              { label: 'Include', value: 'The email address associated with your account' },
            ].map(item => (
              <div key={item.label} style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                <span style={{ fontSize: 13, color: 'var(--white-40)', fontWeight: 600, minWidth: 90, paddingTop: 2 }}>{item.label}:</span>
                <span style={{ fontSize: 14, color: 'var(--white-80)', lineHeight: 1.6 }}>{item.value}</span>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 16, background: 'var(--white-10)', borderRadius: 8, padding: '12px 16px' }}>
            <p style={{ fontSize: 14, color: 'var(--white-60)', lineHeight: 1.6 }}>
              We will process your request within <strong style={{ color: 'var(--white-80)' }}>7 days</strong> and confirm by email once complete.
            </p>
          </div>
        </div>

        {/* What gets deleted */}
        <div className="card" style={{ marginBottom: 32 }}>
          <p style={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.1em', color: 'var(--gold)', marginBottom: 16 }}>
            WHAT GETS DELETED
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {[
              'Your account and login credentials',
              'All generated tapping scripts',
              'Subscription and billing records (payment history retained by Stripe per their legal obligations)',
              'All personal data associated with your account',
            ].map((item, i) => (
              <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                <span style={{ color: 'var(--gold)', fontSize: 16, flexShrink: 0, marginTop: 1 }}>✓</span>
                <p style={{ fontSize: 14, color: 'var(--white-70)', lineHeight: 1.6 }}>{item}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Contact */}
        <p style={{ fontSize: 14, color: 'var(--white-60)', textAlign: 'center', lineHeight: 1.8 }}>
          For questions contact:{' '}
          <a href="mailto:info@michaelhetherington.com" style={{ color: 'var(--gold)', textDecoration: 'none' }}>
            info@michaelhetherington.com
          </a>
        </p>

      </div>
    </div>
  );
}
